import { State } from '../State';
import { convertUTCToClientTime } from './time';
import { duration, getPartOfTime } from '../utils/duration';
import { Locale } from '../ruleset/locale';

export function checkIfUserInNightBlock(
  state: State,
  now: number,
  nightBlockConfig: { start: number; end: number },
): boolean {
  let result = false;

  const clientSideTime = convertUTCToClientTime(now, state);
  const hours = getPartOfTime(clientSideTime, 'hours');
  const hoursTimestamp = duration({ hours: hours });

  // Night block split into 2 parts evening (from start to 24:00) and morning (from 00:00 to end)
  if (
    nightBlockConfig.start <= hoursTimestamp &&
    hoursTimestamp <= duration({ hours: 24 })
  ) {
    result = true;
  } else if (0 <= hoursTimestamp && hoursTimestamp < nightBlockConfig.end) {
    result = true;
  }

  return result;
}

/**
 * Get current player locale
 */
export function getLocale(state: {
  settings: Pick<State['settings'], 'locale'>;
}): Locale {
  return state.settings.locale as Locale;
}
